import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { createTracker } from 'redux-segment';
import { pageMapper } from '@surfline/web-common/dist/segment';
import auth from '../reducers/auth';
import interactions from '../reducers/interactions';
import user from '../reducers/user';
import login from '../reducers/login';
import facebook from '../reducers/facebook';
import forgotPassword from '../reducers/forgotPassword';
import gifts from '../reducers/gifts';
import geo from '../reducers/geo';
import features from '../reducers/features';
import redeem from '../reducers/redeem';
import brand from '../reducers/brand'

export default (initialState, history) => {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const enhancer = composeEnhancers(applyMiddleware(
    thunkMiddleware,
    createTracker(pageMapper),
    routerMiddleware(history),
  ));
  const reducer = combineReducers({
    brand,
    auth,
    interactions,
    user,
    login,
    facebook,
    forgotPassword,
    routing: routerReducer,
    form: formReducer,
    flags: features,
    geo,
    gifts,
    redeem,
  });
  const store = createStore(reducer, initialState, enhancer);
  return store;
};
